module.exports = __webpack_public_path__ + "static/media/person-circle.6882025c.svg";